export const buildGraphQlPayload = (graphql, variables) => {
  return JSON.stringify({
    query: graphql,
    variables: variables
  })
}
